import { render, staticRenderFns } from "./Suivi_Clients.vue?vue&type=template&id=71e299c4&"
import script from "./Suivi_Clients.vue?vue&type=script&lang=js&"
export * from "./Suivi_Clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports